var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoices" },
    [
      _c(
        "div",
        { staticClass: "main-wrapper" },
        [
          _c("layout-header"),
          _vm._v(" "),
          _c("layout-sidebar"),
          _vm._v(" "),
          _c("div", { staticClass: "page-wrapper" }, [
            _c("div", { staticClass: "content container-fluid" }, [
              _c("div", { staticClass: "page-header" }, [
                _c("div", { staticClass: "row align-items-center" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("h3", { staticClass: "page-title" }, [
                      _vm._v("Instagram Official Accounts")
                    ]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "breadcrumb" }, [
                      _c(
                        "li",
                        { staticClass: "breadcrumb-item" },
                        [
                          _c("router-link", { attrs: { to: "/index" } }, [
                            _vm._v("Dashboard")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("li", { staticClass: "breadcrumb-item active" }, [
                        _vm._v("Instagram Accounts")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-auto float-right ml-auto" }, [
                    _c(
                      "a",
                      {
                        ref: "formBc",
                        staticClass: "btn add-btn",
                        attrs: {
                          href: "#",
                          "data-toggle": "modal",
                          "data-target": "#add_form"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showBroadcast(true)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "la la-user" }),
                        _vm._v(" Add Account\n              ")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: false,
                            expression: "false"
                          }
                        ],
                        ref: "formBcEdit",
                        staticClass: "btn add-btn",
                        attrs: {
                          href: "#",
                          "data-toggle": "modal",
                          "data-target": "#add_form"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showBroadcast(false)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-tags" }),
                        _vm._v(" Edit\n              ")
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row filter-row" }, [
                _c("div", { staticClass: "col-sm-6 col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            id: "ajax",
                            label: "license_name",
                            "track-by": "id",
                            placeholder: "Type to search Brand...",
                            multiple: true,
                            "open-direction": "bottom",
                            "custom-label": _vm.customLabel,
                            options: _vm.contactOptions,
                            searchable: true,
                            loading: _vm.isLoading,
                            "internal-search": false,
                            "close-on-select": false,
                            "options-limit": 300,
                            limit: 3,
                            "limit-text": _vm.limitText,
                            "max-height": 600,
                            "show-no-results": true,
                            "hide-selected": true,
                            "show-labels": false
                          },
                          on: { "search-change": _vm.asyncFind },
                          scopedSlots: _vm._u([
                            {
                              key: "tag",
                              fn: function(ref) {
                                var option = ref.option
                                var remove = ref.remove
                                return [
                                  _c("span", { staticClass: "custom__tag" }, [
                                    _c("span", [_vm._v(_vm._s(option.name))]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "custom__remove",
                                        on: {
                                          click: function($event) {
                                            return remove(option)
                                          }
                                        }
                                      },
                                      [_vm._v("❌")]
                                    )
                                  ])
                                ]
                              }
                            },
                            {
                              key: "clear",
                              fn: function(props) {
                                return [
                                  _vm.selectedContact.length
                                    ? _c("div", {
                                        staticClass: "multiselect__clear",
                                        on: {
                                          mousedown: function($event) {
                                            $event.preventDefault()
                                            $event.stopPropagation()
                                            return _vm.clearAll(props.search)
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.selectedContact,
                            callback: function($$v) {
                              _vm.selectedContact = $$v
                            },
                            expression: "selectedContact"
                          }
                        },
                        [
                          _vm._v(" "),
                          _vm._v(" "),
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v("Oops! No elements found.")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-6 col-md-3" }, [
                  _c("div", { staticClass: "form-group form-focus" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.serverParams.username,
                          expression: "serverParams.username"
                        }
                      ],
                      staticClass: "form-control floating",
                      attrs: { type: "text" },
                      domProps: { value: _vm.serverParams.username },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.serverParams,
                            "username",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "focus-label" }, [
                      _vm._v("Username")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-6 col-md-3" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-success btn-block",
                      attrs: { href: "javascript:void(0)" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.filterContactList($event)
                        }
                      }
                    },
                    [_vm._v("Search")]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.selectedTable.length
                ? _c("div", { staticClass: "row filter-row" }, [
                    _c("div", { staticClass: "col-sm-2 col-md-2" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-warning btn-block",
                            attrs: { disabled: _vm.isLoading },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.actionUpdateStatus("logout")
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-sign-out" }),
                            _vm._v("Logout\n              ")
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-2 col-md-2" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-success btn-block",
                            attrs: { disabled: _vm.isLoading },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.actionUpdateStatus("relogin")
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-sign-in" }),
                            _vm._v(" Re-Login\n              ")
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-2 col-md-2" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-danger btn-block",
                            attrs: { disabled: _vm.isLoading },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.actionDelete($event)
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-trash" }),
                            _vm._v(" Delete\n              ")
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-6 col-md-6" }, [
                      _c("div", { staticClass: "text-right" }, [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-xs",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.hideActions($event)
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-close" }),
                            _vm._v(" Close\n              ")
                          ]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _vm.contactListArr.length
                          ? _vm._l(_vm.contactListArr, function(row, idx) {
                              return _c(
                                "div",
                                {
                                  key: idx,
                                  staticClass:
                                    "col-md-12 col-lg-4 col-xl-4 d-flex"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "leave-info-box card flex-fill"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row align-items-center mt-3"
                                        },
                                        [
                                          _c("div", { staticClass: "col-12" }, [
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-3 text-center"
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "squared",
                                                      attrs: {
                                                        href:
                                                          "https://www.instagram.com/" +
                                                          row.username,
                                                        target: "_blank"
                                                      }
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticStyle: {
                                                          width: "100%"
                                                        },
                                                        attrs: {
                                                          alt: "",
                                                          src:
                                                            row.instagram_profile_picture_url
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-9" },
                                                [
                                                  _c(
                                                    "h4",
                                                    [
                                                      _c(
                                                        "router-link",
                                                        {
                                                          attrs: {
                                                            to:
                                                              "/instagram/analytics/profile?instagram_id=" +
                                                              row.instagram_id
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(row.username)
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-sm text-muted"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          row.instagram_name
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm._m(0, true),
                                            _vm._v(" "),
                                            _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "table table-striped"
                                              },
                                              [
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticStyle: {
                                                        width: "40%"
                                                      }
                                                    },
                                                    [_vm._v("Posts")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(row.total_post)
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticStyle: {
                                                        width: "40%"
                                                      }
                                                    },
                                                    [_vm._v("Followers")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        row.total_followers
                                                      )
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticStyle: {
                                                        width: "40%"
                                                      }
                                                    },
                                                    [_vm._v("Following")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        row.total_following
                                                      )
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticStyle: {
                                                        width: "40%"
                                                      }
                                                    },
                                                    [_vm._v("Reach")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      "\n                              " +
                                                        _vm._s(
                                                          row.reach_in_weeks
                                                        ) +
                                                        "\n                              "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-muted"
                                                      },
                                                      [_vm._v("last 7 days")]
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticStyle: {
                                                        width: "40%"
                                                      }
                                                    },
                                                    [_vm._v("Impressions")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      "\n                              " +
                                                        _vm._s(
                                                          row.impressions_in_weeks
                                                        ) +
                                                        "\n                              "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-muted"
                                                      },
                                                      [_vm._v("last 7 days")]
                                                    )
                                                  ])
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-right text-muted"
                                              },
                                              [
                                                _c("small", [
                                                  _vm._v(
                                                    "Last Updated: " +
                                                      _vm._s(
                                                        _vm.timeAgo(
                                                          row.official_api_update_datetime
                                                        )
                                                      )
                                                  )
                                                ])
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "infinite-loading-contact",
                      {
                        attrs: {
                          spinner: "spiral",
                          identifier: _vm.infiniteId
                        },
                        on: { infinite: _vm.infiniteHandlerContact }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "spinner" }, slot: "spinner" },
                          [
                            _vm.loadingMessage
                              ? _c("span", [_vm._v("Loading...")])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { attrs: { slot: "no-more" }, slot: "no-more" },
                          [
                            this.serverParams.totalRecords > 0 &&
                            this.serverParams.rendered >=
                              this.serverParams.totalRecords
                              ? _c("span", [_vm._v("No more messages")])
                              : _vm._e(),
                            _vm._v(" "),
                            this.serverParams.totalRecords == 0
                              ? _c("span", [_vm._v("No more messages")])
                              : _vm._e(),
                            _vm._v(" "),
                            this.serverParams.totalRecords > 0 &&
                            this.serverParams.rendered == 0
                              ? _c("span", [_vm._v("No more messages")])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { attrs: { slot: "no-results" }, slot: "no-results" },
                          [
                            this.serverParams.totalRecords == 0
                              ? _c("span", [_vm._v("No results message")])
                              : _c("span", [_vm._v("No more messages")])
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("form-data")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-left" }, [
      _c("div", { staticClass: "media-body" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0095f656", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0095f656","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/instagram/instagramAccount/listOfficial.vue
// module id = null
// module chunks = 